import Swiper, {Navigation} from 'swiper';

const equalizersRegistry = new WeakMap();
const registeredWrappers = new WeakSet();
const wrappersRegistry = new Set();
const mobileSwiperBreakpoint = 640;
let resizeFrame = null;
let resizeListenerAdded = false;

const getPhaseSlides = (swiperEl) => {
    return Array.from(
        swiperEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')
    );
};

const syncPhasesTitles = (swiperEl) => {
    const equalizer = equalizersRegistry.get(swiperEl);
    const shouldEqualize = swiperEl.classList.contains('no-swiper-type');

    if (!shouldEqualize) {
        if (equalizer) {
            equalizer.destroy();
            equalizersRegistry.delete(swiperEl);
        }

        return;
    }

    if (equalizer) {
        equalizer.refresh();
        return;
    }

    if (typeof window.lineTitlesFunc !== 'function') {
        return;
    }

    equalizersRegistry.set(
        swiperEl,
        window.lineTitlesFunc([], {
            getGroups: () => [
                getPhaseSlides(swiperEl)
                    .map((slide) => slide.querySelector('.phases-card__title'))
                    .filter(Boolean),
            ],
        })
    );
};

const syncPhasesSlideVisibility = (swiperEl) => {
    const swiper = swiperEl.swiper;

    if (!swiper || swiper.destroyed) {
        return;
    }

    getPhaseSlides(swiperEl).forEach((slide) => {
        const exitProgress = Math.min(1, Math.max(0, slide.progress));

        if (exitProgress > 0) {
            slide.style.opacity = 1 - exitProgress;
            slide.style.transform = `scale(${1 - exitProgress * 0.1})`;
            slide.style.zIndex = 0;
            slide.style.pointerEvents = 'none';
        } else {
            slide.style.opacity = '';
            slide.style.transform = '';
            slide.style.zIndex = '';
            slide.style.pointerEvents = '';
        }
    });
};

const resetPhasesSlideVisibility = (swiperEl) => {
    getPhaseSlides(swiperEl).forEach((slide) => {
        slide.style.opacity = '';
        slide.style.transform = '';
        slide.style.zIndex = '';
        slide.style.pointerEvents = '';
    });
};

const setupPhasesSwiper = (wrapper) => {
    const swiperEl = wrapper.querySelector('.swiper');

    if (!swiperEl) {
        return;
    }

    const slidesCount = getPhaseSlides(swiperEl).length;
    const shouldUseStaticLayout = slidesCount < 3 && window.innerWidth > mobileSwiperBreakpoint;

    if (shouldUseStaticLayout) {
        if (swiperEl.swiper && !swiperEl.swiper.destroyed) {
            swiperEl.swiper.destroy(true, true);
        }

        swiperEl.classList.add('no-swiper-type');
        resetPhasesSlideVisibility(swiperEl);
        syncPhasesTitles(swiperEl);
        return;
    }

    swiperEl.classList.remove('no-swiper-type');
    syncPhasesTitles(swiperEl);

    if (swiperEl.swiper && !swiperEl.swiper.destroyed) {
        swiperEl.swiper.update();
        syncPhasesSlideVisibility(swiperEl);
        return;
    }

    const nextEl = wrapper.querySelector('.swiper-button-next');
    const prevEl = wrapper.querySelector('.swiper-button-prev');

    new Swiper(swiperEl, {
        modules: [Navigation],
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        slidesPerView: 1,
        spaceBetween: 20,
        threshold: 10,
        navigation: nextEl && prevEl ? {
            nextEl,
            prevEl,
        } : undefined,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
        },
        on: {
            setTranslate: () => syncPhasesSlideVisibility(swiperEl),
        },
    });

    syncPhasesSlideVisibility(swiperEl);
};

const refreshPhasesSwipers = () => {
    wrappersRegistry.forEach((wrapper) => {
        setupPhasesSwiper(wrapper);
    });
};

const handleResize = () => {
    if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = null;
        refreshPhasesSwipers();
    });
};

const addResizeListener = () => {
    if (resizeListenerAdded) {
        return;
    }

    resizeListenerAdded = true;
    window.addEventListener('resize', handleResize, {passive: true});
};

const initPhasesSwiper = (scope = document) => {
    const wrappers = scope.querySelectorAll('.phases-swiper-wr');

    wrappers.forEach((wrapper) => {
        if (!registeredWrappers.has(wrapper)) {
            registeredWrappers.add(wrapper);
            wrappersRegistry.add(wrapper);
        }

        setupPhasesSwiper(wrapper);
    });

    if (wrappers.length) {
        addResizeListener();
    }
};

initPhasesSwiper();
window.initPhasesSwiper = initPhasesSwiper;
